<template>
  <form class="p-4" @submit.prevent="search">
    <div class="flex items-end">
      <AppLabel label="Från plats*" class="w-full">
        <AppTextField
          :value="model.from.toUpperCase()"
          @input="v => (model.from = v.toUpperCase())"
          padding-inset
          filled
          v-model="model.from"
          placeholder="Från plats"
        />
      </AppLabel>

      <AppButton
        class="border-b border-gray-50"
        :class="[isDisabled && 'pointer-events-none']"
        kind="secondary"
        type="button"
        @click="switchPlaceSearch"
      >
        <i class="material-icons">compare_arrows</i></AppButton
      >

      <AppLabel label="Till plats*" class="w-full">
        <AppTextField
          :value="model.to.toUpperCase()"
          @input="v => (model.to = v.toUpperCase())"
          padding-inset
          filled
          placeholder="Till plats"
        />
      </AppLabel>

      <AppLabel label="Via" class="w-full">
        <AppTextField
          class="border-l border-dotted border-gray-40"
          :value="model.via.toUpperCase()"
          @input="v => (model.via = v.toUpperCase())"
          padding-inset
          filled
          v-model="model.via"
          placeholder="Via"
        />
      </AppLabel>

      <AppButton
        icon="search"
        style="minWidth: 100px"
        type="submit"
        :loading="pending"
        :disabled="isDisabled"
        >Sök</AppButton
      >
    </div>
    <AppTransition>
      <div v-if="error" class="text-red-50 text-sm flex items-center pt-2">
        <i class="material-icons text-sm mr-2">info</i>
        {{ error }}
      </div>
    </AppTransition>
  </form>
</template>

<script>
import { get, sync } from 'vuex-pathify'

export default {
  name: 'TrafficLocationsSearch',

  computed: {
    model: sync('routeLinks/model'),
    pending: get('routeLinks/shortestPath@pending'),
    error: get('routeLinks/shortestPath@error'),

    isDisabled() {
      return !(this.model.from || '').length || !(this.model.to || '').length
    }
  },

  methods: {
    search() {
      if (this.isDisabled) return
      this.$store.dispatch('routeLinks/getShortestPath', this.model)
    },

    switchPlaceSearch() {
      const fromPlace = this.model.from
      const toPlace = this.model.to
      this.model.from = toPlace
      this.model.to = fromPlace

      this.search()
    }
  }
}
</script>
